import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logError } from '@log';
import { addSelectedItems, clearSelectedItems, deleteSelectedItems } from '@store/slices/claimSlice';
import { useBehaviorData } from '@hooks';

export const usePackageCheckbox = () => {
  const {
    fulfilledItems,
    unFulfilledItems, orderName,
  } = useSelector((state) => state.claim);
  const { type, selectedItems } = useSelector((state) => state.claim);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setReportData = useBehaviorData();
  const isContinueBtnDisable = selectedItems.length === 0;

  const onClickContinue = () => {
    if (!selectedItems.length) {
      logError(new Error(`choose ${type}, onClickContinue error`));
      return;
    }
    setReportData({ optionsIssueTime: Date.now(), issueType: type });
    navigate('/17track/upload');
  };

  const handleChange = (event) => {
    const { checked, value } = event.target || {};
    if (!checked) {
      dispatch(deleteSelectedItems(value));
    } else {
      dispatch(addSelectedItems(value));
    }
  };

  const clearItems = () => {
    dispatch(clearSelectedItems());
  };

  return {
    fulfilledItems,
    unFulfilledItems,
    orderName,
    type,
    isContinueBtnDisable,
    selectedItems,
    onClickContinue,
    handleChange,
    clearItems,
  };
};
